import { render, staticRenderFns } from "./TipsPicker.vue?vue&type=template&id=330613fe&scoped=true"
import script from "./TipsPicker.vue?vue&type=script&lang=js"
export * from "./TipsPicker.vue?vue&type=script&lang=js"
import style0 from "./TipsPicker.vue?vue&type=style&index=0&id=330613fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330613fe",
  null
  
)

export default component.exports